

export enum AttendanceType {

    CLOCKED_IN       = 1,
    CLOCKED_OUT      = 2,
    AUTO_CLOCKED_OUT = 3

}
